import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PreviewButton } from "@/components/PdfPreview";
import { UnconvertButton } from "@/components/UnconvertButton";

export const QuoteRowActions = ({ id, displayNo, onDeleted, versionOnly = false, testPrefix, locked = false, fileName }) => {
  const nav = useNavigate();
  const del = async () => {
    const msg = versionOnly ? `Hapus versi ${displayNo} ini saja?` : `Hapus penawaran ${displayNo} beserta seluruh riwayatnya?`;
    if (!window.confirm(msg)) return;
    try {
      await api.delete(`/quotations/${id}`, { params: { version_only: versionOnly } });
      toast.success("Penawaran dihapus");
      onDeleted && onDeleted();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <span className="inline-flex whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
      <PreviewButton icon url={`/quotations/${id}/pdf`} filename={fileName || `${displayNo.replace(/\//g, "-")}.pdf`} title={displayNo} testId={`${testPrefix}-preview`} />
      <Button size="icon" variant="ghost" title="Edit" disabled={locked} onClick={() => nav(`/quotations/${id}?edit=1`)} data-testid={`${testPrefix}-edit`}><Pencil className="h-4 w-4" /></Button>
      {!versionOnly && <UnconvertButton icon id={id} displayNo={displayNo} testId={`${testPrefix}-unconvert`} />}
      <Button size="icon" variant="ghost" title="Hapus" onClick={del} data-testid={`${testPrefix}-delete`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
    </span>
  );
};
